import { render, staticRenderFns } from "./ManageSystem.vue?vue&type=template&id=494d46f6&scoped=true&"
import script from "./ManageSystem.vue?vue&type=script&lang=js&"
export * from "./ManageSystem.vue?vue&type=script&lang=js&"
import style0 from "./ManageSystem.vue?vue&type=style&index=0&id=494d46f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d46f6",
  null
  
)

export default component.exports